<template>
  <v-dialog max-width="550" v-model="dialog.shows.showFilter">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="submit">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="
                    $vuetify.lang.t('$vuetify.payment.cols.accountNumber.title')
                  "
                  autocomplete="off"
                  prepend-icon="mdi-bank"
                  v-model="filter.accountNumber"
                ></v-text-field>
              </v-col>
              <template
                v-if="
                  $auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])
                "
              >
                <v-col class="mb-0 py-0" cols="12" sm="6">
                  <v-text-field
                    :label="
                      $vuetify.lang.t('$vuetify.payment.cols.identifier.title')
                    "
                    autocomplete="off"
                    prepend-icon="mdi-pound"
                    v-model="filter.identifier"
                  ></v-text-field>
                </v-col>
                <v-col class="mb-0 py-0" cols="12" sm="6">
                  <v-text-field
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.payment.cols.remoteIdentifier.title'
                      )
                    "
                    autocomplete="off"
                    prepend-icon="mdi-pound"
                    v-model="filter.remoteIdentifier"
                  ></v-text-field>
                </v-col>
              </template>
              <v-col
                :sm="$auth.check(['ROLE_CLIENT']) ? 12 : 6"
                class="mb-0 py-0"
                cols="12"
              >
                <v-text-field
                  :label="
                    $vuetify.lang.t('$vuetify.payment.cols.invoiceId.title')
                  "
                  autocomplete="off"
                  prepend-icon="mdi-pound"
                  v-model="filter.invoiceId"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="
                    $vuetify.lang.t('$vuetify.payment.cols.reference.title')
                  "
                  autocomplete="off"
                  prepend-icon="mdi-panorama-fisheye"
                  v-model="filter.reference"
                ></v-text-field>
              </v-col>
              <v-col
                class="mb-0 py-0"
                cols="12"
                sm="6"
                v-if="
                  $auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])
                "
              >
                <v-text-field
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.payment.cols.remoteReference.title'
                    )
                  "
                  autocomplete="off"
                  prepend-icon="mdi-panorama-fisheye"
                  v-model="filter.remoteReference"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-select
                  :items="itemsPaymentStatus"
                  :label="$vuetify.lang.t('$vuetify.payment.cols.status.title')"
                  autocomplete="off"
                  clearable
                  prepend-icon="mdi-flag"
                  v-model="filter.status"
                ></v-select>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-menu
                  :close-on-content-click="false"
                  :return-value.sync="filter.createdAt.start"
                  min-width="290px"
                  offset-y
                  ref="starts"
                  transition="scale-transition"
                  v-model="menus.start"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :errorMessages="startAtErrors"
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.payment.cols.created.start.title'
                        )
                      "
                      @blur="$v.filter.createdAt.start.$touch()"
                      @input="$v.filter.createdAt.start.$touch()"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-model="filter.createdAt.start"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :max="maxDate"
                    no-title
                    scrollable
                    v-model="filter.createdAt.start"
                  >
                    <v-spacer></v-spacer>
                    <v-btn @click="menus.start = false" color="primary" text
                      >Cancel
                    </v-btn>
                    <v-btn
                      @click="$refs.starts.save(filter.createdAt.start)"
                      color="primary"
                      text
                      >OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-menu
                  :close-on-content-click="false"
                  :return-value.sync="filter.createdAt.end"
                  min-width="290px"
                  offset-y
                  ref="ends"
                  transition="scale-transition"
                  v-model="menus.end"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :errorMessages="endAtErrors"
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.payment.cols.created.end.title'
                        )
                      "
                      @blur="$v.filter.createdAt.end.$touch()"
                      @input="$v.filter.createdAt.end.$touch()"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-model="filter.createdAt.end"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :max="filter.createdAt.end"
                    no-title
                    scrollable
                    v-model="filter.createdAt.end"
                  >
                    <v-spacer></v-spacer>
                    <v-btn @click="menus.end = false" color="primary" text
                      >Cancel
                    </v-btn>
                    <v-btn
                      @click="$refs.ends.save(filter.createdAt.end)"
                      color="primary"
                      text
                      >OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-autocomplete
                  :items="itemsApplications"
                  :label="
                    $vuetify.lang.t('$vuetify.payment.cols.application.title')
                  "
                  :loading="isLoadingApp"
                  :search-input.sync="searchApp"
                  autocomplete="off"
                  clearable
                  hide-no-data
                  hide-selected
                  prepend-icon="mdi-apps"
                  v-model="filter.application"
                ></v-autocomplete>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-select
                  :items="itemsTransactions"
                  :label="
                    $vuetify.lang.t('$vuetify.payment.cols.transaction.title')
                  "
                  autocomplete="off"
                  clearable
                  prepend-icon="mdi-transfer"
                  v-model="filter.transaction"
                ></v-select>
              </v-col>
              <v-col
                class="mb-0 py-0"
                cols="12"
                sm="6"
                v-if="
                  $auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])
                "
              >
                <v-autocomplete
                  :items="itemsUsers"
                  :label="$vuetify.lang.t('$vuetify.payment.cols.user.title')"
                  :loading="isLoadingUser"
                  :search-input.sync="searchUser"
                  autocomplete="off"
                  hide-no-data
                  hide-selected
                  prepend-icon="mdi-account-group-outline"
                  v-model="filter.user"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.shows.showFilter = false" text
            >{{ $vuetify.lang.t("$vuetify.btn.close") }}
          </v-btn>
          <v-btn @click="resetForm" text
            >{{ $vuetify.lang.t("$vuetify.btn.reset") }}
          </v-btn>
          <v-btn :loading="loadingBtn" color="secondary" text type="submit"
            >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import URLPath from "../../helpers/URL";
import { mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import { dateIsGreatThan } from "../../helpers/Validators";
import FilterMixin from "../../mixins/Common/Filters";

export default {
  mixins: [FilterMixin],
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.payment.filter.title",
          shows: {
            showFilter: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "filter"
        };
      }
    },
    filter: {
      type: Object,
      default: function() {
        return {
          accountNumber: null,
          identifier: null,
          remoteIdentifier: null,
          invoiceId: null,
          application: null,
          reference: null,
          remoteReference: null,
          user: null,
          type: null,
          createdAt: {
            start: null,
            end: null
          }
        };
      }
    }
  },
  watch: {
    searchApp(val) {
      if (!val) return;
      if (val.length < 3) return;
      const query = "a_name::iLike::%" + val + "%";
      const params = {
        url: URLPath.APPLICATION.LIST,
        params: {
          _search: query
        }
      };
      this.getApplications(params);
    },
    searchUser(val) {
      if (!val) return;
      if (val.length < 3) return;
      const query = "u_username::iLike::%" + val + "%";
      const params = {
        url: URLPath.USER.LIST,
        params: {
          _search: query
        }
      };
      this.getUsers(params);
    }
  },
  created() {
    this.setItemTransactions();
    this.setItemPaymentStatus();
  },
  validations() {
    let validators = {
      filter: {
        createdAt: {
          start: {
            required: requiredIf(component => {
              return component.start;
            })
          },
          end: {
            required: requiredIf(component => {
              return component.start;
            }),
            dateIsGreatThan
          }
        }
      }
    };
    return validators;
  },
  data: () => ({
    itemsApplications: [],
    itemsTransactions: [],
    itemsOperators: [],
    itemsPaymentStatus: [],
    itemsUsers: [],
    searchApp: null,
    searchUser: null,
    isLoadingApp: false,
    isLoadingUser: false,
    menus: {
      start: false,
      end: false
    },
    maxDate: new Date().toISOString().substr(0, 10)
  }),
  methods: {
    getApplications(params) {
      let self = this;
      this.isLoadingApp = true;
      this.$store
        .dispatch("request", params)
        .then(r => {
          r.data.items.forEach(app => {
            self.itemsApplications.push({
              text: app.name,
              value: app.id
            });
          });
        })
        .finally(() => {
          self.isLoadingApp = false;
        });
    },
    getUsers(params) {
      let self = this;
      this.isLoadingUser = true;
      this.$store
        .dispatch("request", params)
        .then(r => {
          r.data.items.forEach(app => {
            self.itemsUsers.push({
              text: app.username,
              value: app.id
            });
          });
        })
        .finally(() => {
          self.itemsUsers = self._.uniqBy(self.itemsUsers, "value");
          self.isLoadingUser = false;
        });
    },
    setItemTransactions() {
      let self = this;
      this.transactions.forEach(r => {
        self.itemsTransactions.push({
          text: self.$vuetify.lang.t("$vuetify.transactions." + r),
          value: r
        });
      });
    },
    setItemPaymentStatus() {
      let self = this;
      this.paymentStatus.forEach(r => {
        self.itemsPaymentStatus.push({
          text: self.$vuetify.lang.t("$vuetify.paymentStatus." + r),
          value: r
        });
      });
    },
    resetForm() {
      this.filter.application = null;
      this.filter.status = null;
      this.filter.reference = null;
      this.filter.remoteReference = null;
      this.filter.identifier = null;
      this.filter.remoteIdentifier = null;
      this.filter.user = null;
      this.filter.transaction = null;
      this.filter.createdAt = { start: null, end: null };
      this.$v.$reset();
      this.performFilter();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.performFilter();
      }
    }
  },
  computed: {
    ...mapGetters({
      transactions: "payment/transactions",
      paymentStatus: "payment/status"
    }),
    startAtErrors() {
      const errors = [];
      if (!this.$v.filter.createdAt.start.$dirty) return errors;
      !this.$v.filter.createdAt.start.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.payment.cols.created.start.required")
        );
      return errors;
    },
    endAtErrors() {
      const errors = [];
      let min = this.$vuetify.lang.t(
        "$vuetify.payment.cols.created.start.title"
      );
      if (!this.$v.filter.createdAt.end.$dirty) return errors;
      !this.$v.filter.createdAt.end.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.payment.cols.created.end.required")
        );
      !this.$v.filter.createdAt.end.dateIsGreatThan &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.payment.cols.created.end.isGreatThan",
            [min]
          )
        );
      return errors;
    }
  }
};
</script>

<style scoped></style>
